import clsx from 'clsx'

/**
 * Иконка для заглушек разделов («Скоро»): круг + стрелки, без одного «ломаного» path; стрелки крутятся.
 */
export function SectionPlaceholderIcon({ className }: { className?: string }) {
  const stroke = 1.25
  return (
    <svg
      className={clsx('stryzh-section-placeholder-icon', className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth={stroke} />
      {/* Центр часов (0,0) — translate(12,12) */}
      <g transform="translate(12 12)">
        <circle cx="0" cy="0" r="0.9" fill="currentColor" />
        <g className="stryzh-section-placeholder-icon__hour">
          <line
            x1="0"
            y1="0"
            x2="-2.2"
            y2="-4.2"
            stroke="currentColor"
            strokeWidth={stroke}
            strokeLinecap="round"
          />
        </g>
        <g className="stryzh-section-placeholder-icon__minute">
          <line
            x1="0"
            y1="0"
            x2="0"
            y2="-6.8"
            stroke="currentColor"
            strokeWidth={stroke}
            strokeLinecap="round"
          />
        </g>
      </g>
    </svg>
  )
}
